import React, {Component} from "react";
import {forEach, map, isNumber, get} from "lodash";
import {Translation} from "react-i18next";
import {Empty, Table, Tabs} from "antd";
import {StarFilled} from "@ant-design/icons";
import "../components/Exchange";
import consts, {PREFIX_FRONT_URL} from "../consts";
import utils from "../common/utils";
import FooterComponent from "./common/FooterComponent";
import LightWeightChart from "./common/LightWeightChart"

const { TabPane } = Tabs;

class MarketPlace extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favorites: [],
      isFavorite: false,
      currencyForLightChart: [],
      loading: false,
    };
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.setting !== this.props.setting) {
      //Perform some operation
      this.handleGetCurrencyForLightChart();
      // ....
    }
    if(nextProps.favorites !== this.props.favorites){
      this.setState({loading: false})
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.state.currencyForLightChart.length === 0 &&
      this.state.currencyForLightChart !== nextState.currencyForLightChart &&
      nextProps.currencyLightChart.length === 0
    ) {
      this.props.fetchPriceMarket24h(nextState.currencyForLightChart);
    }
    return true;
  }

  //function
  handleGetCurrencyForLightChart = () => {
    if (this.props?.setting?.currencyMarkets?.all !== undefined) {
      let sortAll = this.props?.setting?.currencyMarkets?.all;
      sortAll.sort(function (a, b) {
        return b.volume - a.volume;
      });

      this.setState({
        currencyForLightChart: sortAll.slice(0, 4),
      });
    }
  };


  handleFavorites = (value) => {
    if (window.$isAuthenticated) {
      this.setState({loading: true})
      if (value.isChecked) {
        value.isChecked = false;
        this.props.fetchDeleteFavoritesAction(value);
      } else {
        value.isChecked = true;
        this.props.fetchUpdateFavoritesAction(value);
      }
    } else {
      if (value.isChecked) {
        value.isChecked = false;
        this.props.localFetchDeleteFavoritesAction(value);
      } else {
        value.isChecked = true;
        this.props.localFetchUpdateFavoritesAction(value);
      }
    }
  };

  onTradeNow = (value) => {
    const { coin, currency } = value;
    window._.get(this.props, "changeMarket", () => { })(coin, currency);
    this.props.history.push(
      `${PREFIX_FRONT_URL}/?currency=${coin}/${currency}`
    );
  };

  //get avaiable last price of coin have last price to usdt
  getLastPriceAvailableToUSDT = (coin) => {
    let mapCurrencyMarketsUSDT = get(this.props.setting.mapCurrencyMarkets, "USDT", {});
    let result = "cant change to USDT directly";
    forEach(Object.keys(mapCurrencyMarketsUSDT), (symbol) => {
      if (symbol === coin) {
        result = mapCurrencyMarketsUSDT[symbol].last_price;
      }
    });
    return result;
  };

  getLastPriceToUSDT = (coin) => {
    let mapCurrencyMarkets = this.props.setting.mapCurrencyMarkets;
    let result = 0;
    if (coin === "USDT") return 1;
    else if (
      this.getLastPriceAvailableToUSDT(coin) !== "cant change to USDT directly"
    ) {
      result = this.getLastPriceAvailableToUSDT(coin);
    }
    else if(this.getLastPriceAvailableToUSDT(coin) === "cant change to USDT directly"){
      result = "cant change to USDT directly"
    }
    else {
      forEach(Object.keys(mapCurrencyMarkets), (symbol) => {
        if (symbol !== "USDT") {
          forEach(Object.keys(mapCurrencyMarkets[symbol]), (symbolCoin) => {
            if (symbolCoin === coin) {
              //return last price to symbolCoin * with last price from symbolCoin to USDT
              result =
                mapCurrencyMarkets[symbol][symbolCoin].last_price *
                this.getLastPriceAvailableToUSDT(symbolCoin);
            
            }
          });
        }
      });
    }
    return result;
  };

  columns = [
    {
      title: "Coin",
      width: 100,
      dataIndex: "coin",
      key: "coin",
      className: "text-left",
      render: (coin) => `${coin}`.toUpperCase(),
    },
    {
      title: "Price",
      width: 100,
      dataIndex: "last_price",
      key: "last_price",
      className: "text-left",
      render: (lastPrice, market) => (
        <div style={{ ...(market.style || {}) }}>{utils.formatCurrency(lastPrice)}</div>
      ),
    },
    {
      title: <div className="text-left">Volume</div>,
      width: 100,
      dataIndex: "volume",
      key: "volume",
      className: "text-left",
    },
    {
      title: <div className="text-left">Change</div>,
      width: 100,
      dataIndex: "change",
      key: "change",
      className: "text-left",
      render: (change) => (
        <div
          style={{
            color:
              window._.get(this.props.data, "change", 0) > 0
                ? "#3f8600"
                : "#cf1322",
          }}
        >
          {change}
        </div>
      ),
    },
    {
      title: "Name",
      width: 100,
      dataIndex: "coin",
      key: "coin",
      className: "text-left",
      render: (coin) => (
        <div>
          {window._.get(this.props.setting.coins[`${coin}`], "name", "")}
        </div>
      ),
    },
  ];

  columnsLandingPage = (t) => [
    {
      title: (
        <div className=" pl-small text-left-header">
          {t("user.open_order.pair")}
        </div>
      ),
      width: 240,
      dataIndex: "coin",
      key: "coin",
      className: "text-left",
      render: (coin, value) => (
            <div className="d-flex fz-normal pl-small">
              <div
                className={`mr-small ${value.isChecked ? "favorites-true" : "favorites-fasle"}`}
                onClick={() => this.handleFavorites(value)}
              >
                <StarFilled />
              </div>
              <div className="text-color-theme">
                {`${coin} / `}
                <span>{value.currency}</span>
              </div>
            </div>
          )
    },
    {
      title: <div className="text-left-header">{t("landing.last_price")}</div>,
      width: 300,
      dataIndex: "last_price",
      key: "last_price",
      className: "text-left",
      sorter: {
        compare: (b, a) => a.last_price - b.last_price,
      },
      render: (lastPrice, market) =>  {
        return <div className="last-price fz-normal">{`${utils.formatCurrency(lastPrice)} / `}
        {isNumber(this.getLastPriceToUSDT(market.currency)) ?
          <span className="change-to-USDT-table">
            {`$${Math.round(lastPrice * this.getLastPriceToUSDT(market.currency) * 100) / 100}`}
            </span>
            : "--"
      }
        </div>;
      },
    },
    {
      title: <div className="text-left-header">{t("landing.change_24h")}</div>,
      width: 220,
      dataIndex: "change",
      key: "change",
      align: "left",
      className: "text-left",
      sorter: {
        compare: (b, a) => a.change - b.change,
      },
      render: (change) => (
        <div
          className="d-flex fz-normal"
          style={{ color: change >= 0 ? "#3f8600" : "#cf1322" }}
        >
          {change} %
        </div>
      ),
    },
    {
      align: "left",
      title: <div className="text-left-header">{t("landing.high")}</div>,
      width: 240,
      dataIndex: "high",
      key: "high",
      className: "text-left",
      sorter: {
        compare: (b, a) => a.high - b.high,
      },
      render: (high) => (
        <div
          className="d-flex fz-normal"
          style={{
            color:
              window._.get(this.props.data, "high", 0) > 0
                ? "#3f8600"
                : "#cf1322",
          }}
        >
          {utils.formatCurrency(high)}
        </div>
      ),
    },
    {
      align: "left",
      title: <div className="text-left-header">{t("landing.low")}</div>,
      width: 240,
      dataIndex: "low",
      key: "low",
      className: "text-left",
      sorter: {
        compare: (b, a) => a.low - b.low,
      },
      render: (low) => (
        <div
          className="d-flex fz-normal"
          style={{
            color:
              window._.get(this.props.data, "low", 0) > 0
                ? "#3f8600"
                : "#cf1322",
          }}
        >
          {utils.formatCurrency(low)}
        </div>
      ),
    },
    {
      align: "left",
      title: <div className="text-left-header">{t("landing.volume")}</div>,
      width: 200,
      dataIndex: "volume",
      key: "volume",
      sorter: {
        compare: (b, a) => a.volume - b.volume,
      },
      render: (volume) => (
        <div className="pr-medium d-flex fz-normal">{utils.formatCurrency(volume)}</div>
      ),
    },
    {
      title: <div className="text-left-header fz-normal">{t("landing.volume")}</div>,
      width: 220,
      dataIndex: "change",
      key: "change",
      align: "right",
      render: (coin, value) => (
        <div className="block" onClick={() => this.onTradeNow(value)}>
          {t("user.deposit.go_trade")}
        </div>
      ),
    },
  ];

  render() {
    return (
      <Translation>
        {(t) => (
          <div className=" landing landing-market">
            <div className="landing-layout1">
              <div className="max-width ma">
                <div className="market-wrap">
                  {/* light chart */}
                  <div
                    className="light-charts"
                    style={{
                      display: "flex",
                      color: "black",
                      margin: "0px 10px",
                    }}
                  >
                    {map(this.props.currencyLightChart ? this.props.currencyLightChart : [], (object, index) => {
                      return (
                        <div
                          className="chart"
                          style={{
                            flex: 2.2,
                            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
                          }}
                        >
                          <div style={{ flex: 1, display: "flex" }}>
                            <div style={{ flex: 1 }}>
                              <div
                                style={{ fontSize: "13px", textAlign: "left" }}
                              >
                                {`${object.coin} /
                                ${object.currency}`}
                              </div>
                              <div
                                style={{
                                  textAlign: "left",
                                  fontSize: "22px",
                                  color: "#5f5890",
                                  fontWeight: "bold",
                                }}
                              >
                                {Math.round(object.last_price * 10000) / 10000}{" "}

                                <span className="change-to-USDT">
                                  {`$ ${!!object.last_price ? Math.round(object.last_price *
                                    this.getLastPriceToUSDT(object.currency) * 10000) / 10000 : '--'}`}
                                </span>
                              </div>
                            </div>
                            <div>
                              <LightWeightChart
                                dataChart={object.data}
                                coin={object.coin}
                                currency={object.currency}
                                index={index}
                              />
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              fontSize: "13px",
                              padding: "0px 10px",
                            }}
                          >
                            <div
                              style={{
                                color: object.change > 0 ? "green" : "red",
                                paddingRight: "10px",
                              }}
                            >
                              {`${object.change}%`}
                            </div>
                            <div>
                              Volume: {Math.round(object.volume * 1000) / 1000}{" "}
                              {object.currency}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="tab-table">
                    <Tabs
                      animated={false}
                      style={{ fontSize: "30px" }}
                      defaultActiveKey="1"
                      className="text-left"
                    >
                      <TabPane key="2" tab={t("market.favorite")}>
                        <Table
                          locale={{
                            emptyText: (
                              <Empty
                                description={
                                  <span className="bold">
                                    {window.$t("common.empty")}
                                  </span>
                                }
                              />
                            ),
                          }}
                          columns={
                            !!this.props.isLandingPage
                              ? this.columnsLandingPage(t, this.props.coins)
                              : this.columns
                          }
                          rowClassName="pointer"
                          style={{
                            maxWidth: consts.MAX_WIDTH,
                            overflow: "auto",
                          }}
                          scroll={false}
                          pagination={false}
                          dataSource={this.props.favorites}
                          className="mb-large"
                          loading={this.state.loading}
                        />
                      </TabPane>
                      <TabPane key="1" tab={t("market.market")}>
                        <Tabs
                          type="card"
                          className="text-left"
                          tabBarGutter={5}
                          tabBarStyle={{
                            borderWidth: 0,
                            borderColor: "#FFFFFF",
                            borderBottomWidth: 2,
                            borderStyle: "solid",
                            paddingLeft: 0,
                            marginBottom: 0,
                            fontWeight: 500,
                          }}
                        >
                          {window._.map(
                            this.props.currencyMarkets,
                            (markets, currency) => {
                              return (
                                <TabPane
                                  tab={
                                    <div
                                      style={{ width: 88, textAlign: "center" }}
                                    >
                                      {currency === "all"
                                        ? t("market.all").toUpperCase()
                                        : currency.toUpperCase()}
                                    </div>
                                  }
                                  key={currency}
                                >
                                  <Table
                                    locale={{
                                      emptyText: (
                                        <Empty
                                          description={
                                            <span className="bold">
                                              {window.$t("common.empty")}
                                            </span>
                                          }
                                        />
                                      ),
                                    }}
                                    columns={
                                      !!this.props.isLandingPage
                                        ? this.columnsLandingPage(
                                          t,
                                        )
                                        : this.columns
                                    }
                                    rowClassName="pointer"
                                    style={{
                                      maxWidth: consts.MAX_WIDTH,
                                      overflow: "auto",
                                    }}
                                    scroll={false}
                                    pagination={false}
                                    dataSource={[...markets || []]}
                                    className="mb-large"
                                  />
                                </TabPane>
                              );
                            }
                          )}
                        </Tabs>
                      </TabPane>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer">
              <FooterComponent />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default MarketPlace;

